import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IGetToastAutoDismissSettingParams {
}

export interface IGetToastAutoDismissSettingResult extends IResult {
  timeout: number;
}
export class GetToastAutoDismissSettingRequest extends Request<IGetToastAutoDismissSettingParams, IResult> {
  constructor(params: IGetToastAutoDismissSettingParams) {
    super('getToastAutoDismissSetting', params);
  }
}
